import { User } from "./user";

export class ProjectLookback {
  id: string;
  projectCode: string = "";
  projectName: string = "";
  projectAdmins: User[];
  asset: string[] = [];
  status: string;
  userCount: number;
  businessUnit: string;
  projectStartDate: Date;
  projectDeadline: Date;
  workflowType: string;
  participants: User[];
  pendingParticipants: User[];
  participantsToNotify: User[];
  isParticipantOfProjectLookback: boolean;
  isProjectLookbackEditable: boolean = false;
  transitionName: string;
  pendingStatus: string;
  previousStatus: string;
  lessonIds: string[] = [];
  teamComments: string;
  projectId: string;
  lessonExtensionType: string;
  lessons: any[] = []; //fe variable
  lessonStatuses: any[] = []; // fe
  updateDate: Date;

  //add project metrics fields
  totalRecordableInjuryRateTarget: number;
  totalRecordableInjuryRateActual: number;
  daysAwayFromWorkCasesTarget: number;
  daysAwayFromWorkCasesActual: number;
  totalAFEAmountTarget: number;
  totalAFEAmountActual: number;
  totalAFEAmountDeviation: number;
  totalAFEAmountComments: string;
  changeOrderTarget: number;
  changeOrderActual: number;
  changeOrderDeviation: number;
  changeOrderComments: string;
  costSavingTarget: number;
  costSavingActual: number;
  costSavingDeviation: number;
  costSavingComments: string;
  projectCostPerformanceTotalTarget: number;
  projectCostPerformanceTotalActual: number;
  onboardGCTarget: Date;
  onboardGCActual: Date;
  onboardGCDeviation: number;
  onboardGCComments: string;
  ddTenantApprovalTarget: Date;
  ddTenantApprovalActual: Date;
  ddTenantApprovalDeviation: number;
  ddTenantApprovalComments: string;
  constructionStartTarget: Date;
  constructionStartActual: Date;
  constructionStartDeviation: number;
  constructionStartComments: string;
  cdTenantApprovalTarget: Date;
  cdTenantApprovalActual: Date;
  cdTenantApprovalDeviation: number;
  cdTenantApprovalComments: string;
  gmpApprovalTarget: Date;
  gmpApprovalActual: Date;
  gmpApprovalDeviation: number;
  gmpApprovalComments: string;
  buildingPermitApprovedTarget: Date;
  buildingPermitApprovedActual: Date;
  buildingPermitApprovedDeviation: number;
  buildingPermitApprovedComments: string;
  substantialCompletionTarget: Date;
  substantialCompletionActual: Date;
  substantialCompletionDeviation: number;
  substantialCompletionComments: string;
  projectCompletionTarget: Date;
  projectCompletionActual: Date;
  projectCompletionDeviation: number;
  projectCompletionComments: string;
  projectCycleTimeTarget: number;
  projectCycleTimeActual: number;
  projectCycleTimeDeviation: number;
  projectCycleTimeComments: string;
}

export class ProjectLookbackFieldUpdate {
  projectLookback: ProjectLookback;
  fieldId: string;
}
